import { useCallback, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export function usePhytosanitaryApplicationModalUrl({ applicationForm, programData }) {
	const location = useLocation();
	const navigate = useNavigate();

	const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

	const applicationFormMode = searchParams.get("modal") || null;
	const rowId = searchParams.get("row_id") || null;
	const appNum = searchParams.get("app_num") || null;

	const applicationFormRows = useMemo(() => {
		if (applicationFormMode !== "add_product" || !rowId || !appNum || !programData) return [];
		return programData.filter((row) => String(row.id) === rowId && String(row.application_number) === appNum);
	}, [applicationFormMode, rowId, appNum, programData]);

	const applicationFormRow = useMemo(() => {
		return applicationFormRows[0] || null;
	}, [applicationFormRows]);

	const { resetForm, prefillFromRow } = applicationForm;

	useEffect(() => {
		if (applicationFormMode === "new_application") {
			resetForm();
		}
	}, [applicationFormMode, resetForm]);

	useEffect(() => {
		if (applicationFormMode === "add_product" && applicationFormRow) {
			prefillFromRow(applicationFormRow, applicationFormRows);
		}
	}, [applicationFormMode, applicationFormRow, applicationFormRows, prefillFromRow]);

	const openNewApplication = useCallback(() => {
		navigate({ search: "?modal=new_application" });
	}, [navigate]);

	const openAddProduct = useCallback(
		(row) => {
			navigate({ search: `?modal=add_product&row_id=${row.id}&app_num=${row.application_number}` });
		},
		[navigate],
	);

	const closeApplicationForm = useCallback(() => {
		navigate({ search: "" });
		resetForm();
	}, [navigate, resetForm]);

	return { applicationFormMode, applicationFormRow, applicationFormRows, openNewApplication, openAddProduct, closeApplicationForm };
}
